import { render } from "./ChatInputTemplateOverlay.vue?vue&type=template&id=4301bd66&scoped=true&ts=true"
import script from "./ChatInputTemplateOverlay.vue?vue&type=script&lang=ts"
export * from "./ChatInputTemplateOverlay.vue?vue&type=script&lang=ts"

import "./ChatInputTemplateOverlay.vue?vue&type=style&index=0&id=4301bd66&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4301bd66"]])

export default __exports__